export const QUERY_PARAM_IS_SHOW_TEMPLATES_MODAL = 'isShowTemplatesModal';
export const QUERY_PARAM_CURRENT_OPENED_TAB = 'tab';
export const QUERY_PARAM_OPENED_TASK = 'taskId';
